/** Class performing actions within the main content container */
class GoogleTagManager {
    /**
     * Define GoogleTagManager container
     */
    constructor(elem) {
        this.elem = elem;

    }

    /**
     * Initialization method
     */
    init() {
        this.addCf7EventListeners();
    }

    addCf7EventListeners() {

        document.addEventListener('wpcf7mailsent', (event) => {
            const formTitle = this.getFormTitle(event);
            let currentForm = document.getElementById(event.detail.unitTag);
            let nextSibling = currentForm.nextElementSibling;
            if (nextSibling.classList.contains("show-after-submit")) {
                nextSibling.classList.remove("show-after-submit");
            }
            const companyDescription = this.getCompanyDescription(event);

            window.dataLayer.push({
                'event': 'formSubmission',
                'formTitle': formTitle, // variable value based on form title or page title/path
                'formStatus': 'successful',
                'invalidFields': [], // include field names of invalid or missing form fields or leave blank when
                "companyDescription" : companyDescription
            });

        }, false);

        document.addEventListener('wpcf7invalid', (event) => {
            const formTitle = this.getFormTitle(event);
            const invalidFields = this.getInvalidFields(event);

            window.dataLayer.push({
                'event': 'formSubmission',
                'formTitle': formTitle, // variable value based on form title or page title/path
                'formStatus': 'failed',
                'invalidFields': invalidFields // include field names of invalid or missing form fields or leave blank when
            });
        }, false);

        // send a Datalayer Event when the user first starts editing the forms.
        const cf7Forms = document.querySelectorAll('.wpcf7-form');
        const isFirstInput = {};

        cf7Forms.forEach(function (form) {

            const formInputs = form.elements;
            const formId = form.elements['_wpcf7'].value
            const formTitle = form.elements['_sf_form_name'].value

            isFirstInput[formId] = false;

            Array.from(formInputs).forEach(function (input) {
                input.addEventListener('input', function (event) {

                    if (!isFirstInput[formId]) {
                        //console.log(`First input in ${formId}!`);

                        window.dataLayer.push({
                            'event': 'formStart',
                            'formTitle': formTitle, // variable value based on form title or page title/path
                        });

                        // Reset the flag to prevent the event from triggering again
                        isFirstInput[formId] = true;
                    }
                }, false);
            });
        });
    }

    getFormTitle(event) {
        for (let i = 0; i < event.target.length; i++) {
            if (event.target[i].name === '_sf_form_name') {
                return event.target[i].defaultValue;
            }
        }
        return false;
    }

    getInvalidFields(event){
        let fields = [];
        for (let i = 0; i < event.detail.apiResponse.invalid_fields.length; i++) {
            fields.push( event.detail.apiResponse.invalid_fields[i].field );
        }
        return fields;
    }

    getCompanyDescription(event){

        for (let i = 0; i < event.detail.inputs.length; i++) {
            if ( event.detail.inputs[i].name === 'company_record_type' ){
                return event.detail.inputs[i].value
            }
        }

        return false;
    }


}

export default GoogleTagManager;
